import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector} from 'react-redux';
import { useLocation } from 'react-router-dom';
import './Navbar.scss';
import VerizonDarkLogo from '../../../assets/images/graphics/VerizonLogoDarkTrans.svg';
import VerizonLogo from '../../../assets/images/graphics/VerizonLogoTrans.svg';
// Custom components
import CloseIcon from '../CloseIcon/CloseIcon';
import ToggleMenu from '../ToggleMenu/ToggleMenu';

import { setMenuOpened, setSkipNavbarADA, setNavBarState } from '../../../store/reducers/mainReducer';

import { Paths, NavbarContent, NavbarLink } from '../../../models/Models';
import { ADAARIARoles, ADALandmarks, ADAWidgitRoles } from '../../../models/ADA';
import { useMediaQuery } from 'react-responsive';
import { EqualStencilFunc } from 'three';

const Navbar = () => {
  const dispatch = useDispatch();
  const lightMode = false;
  const globalData = useSelector(state => state.data.cms.global);
  const showNavbar = useSelector(state => state.data.showNavBar);
  const dmnavbar = useSelector(state => state.data.menus.digitalMuseum);
  const aboutnavbar = useSelector(state => state.data.menus.about);
  const themuseumnavbar = useSelector(state => state.data.menus.theMuseum);
  const storyArchive = useSelector(state => state.data.cms.digitalMuseum.StoryArchive);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const isShowingCredoPopup = useSelector(state => state.data.isShowingCredoPopup);
  //const shouldSkipNavbarADA = useSelector(state => state.data.shouldSkipNavbarADA);
  const [cursor, setCursor] = useState(0);
  const [desktopMenuOpened, setDesktopMenuOpened] = useState(false);
  const [desktopMenuCloseIntent, setDesktopMenuCloseIntent] = useState(false);
  const { pathname } = useLocation();
  const navContainer = useRef(null);
  //const modal = useRef(null);
  const isDesktopView = useMediaQuery({ query: '(min-width: 1020px)' });

  function handleClick() {
    console.log("CHecking click")
    let modal = document.getElementById("modal");
    if (modal && !menuOpened && typeof modal.showModal === 'function') {
      
      modal.showModal();
    }
    else if (modal && menuOpened && typeof modal.close === 'function') {
      console.log("Closing!")
      modal.close();
    }
    setNavMenu(!menuOpened);
    setMenu(!menuOpened);
  }

  useEffect(() => {
    
    document.addEventListener('focus', handleDesktopFocusIn, true);
    document.addEventListener('blur', handleDesktopFocusOut, true);

    
    return (() => {
      document.removeEventListener('focus', handleDesktopFocusIn, true)
      document.removeEventListener('blur', handleDesktopFocusOut, true)
    })
 })

  function handleDesktopKeyPress() {
    console.log("toggle")
    setDesktopMenuOpened(!desktopMenuOpened);
    setNavMenu(true);
  }

  function handleDesktopFocusIn() {
      if (desktopMenuOpened && !document.activeElement.classList.contains("nav-links")) {
        
        setDesktopMenuOpened(false);
        document.removeEventListener('focus', handleDesktopFocusIn);
      }
  }

  function handleDesktopFocusOut(e) {
    if (e && e.target && e.target.className && e.target.classList.contains("nav-links")) {

      document.activeElement.tabIndex = -1;
      
    }
  }

  function handleMenuItemKeyDown(e, currentMenuIndex) {
  
    
    let navItems = Array.from(document.getElementsByClassName("nav-links"));
    
    navItems = navItems.filter(item => item.slot == currentMenuIndex && item.slot != "");

    //find active NavItemIndex
    let currentNavItemIndex = -1;
    navItems.forEach((value, index, array) => { if (value.tabIndex === 1) currentNavItemIndex = index; return; })

    // arrow down/up button should select next/previous list element
    if (e.keyCode === 38 && (currentNavItemIndex === -1 || currentNavItemIndex - 1 >= 0)) {//up arrow
      if (!desktopMenuOpened)
        handleDesktopKeyPress();
      
      if (currentNavItemIndex === -1) {
        currentNavItemIndex = 1;
      }
      
      navItems[currentNavItemIndex].tabIndex = -1;
      navItems[currentNavItemIndex - 1].tabIndex = 1;
      navItems[currentNavItemIndex - 1].focus();
      
    }
    else if (e.keyCode === 40 && currentNavItemIndex + 1 < navItems.length) {//down arrow
      console.log(navItems.length)
      if (!desktopMenuOpened)
        handleDesktopKeyPress();
      if(currentNavItemIndex >= 0)
        navItems[currentNavItemIndex].tabIndex = -1;
      navItems[currentNavItemIndex + 1].tabIndex = 1;
      navItems[currentNavItemIndex + 1].focus();
    }
  }

  var featuredStoriesContent = [
    new NavbarContent(globalData.Navbar.StoryMenuHeader, dmnavbar),
  ];  
  var exhibitContent = [
    new NavbarContent(globalData.Navbar.ExhibitsMenuHeader, themuseumnavbar), 
    new NavbarContent("",aboutnavbar)
  ];
  var mobileContent = [
    new NavbarContent(globalData.Navbar.Text2, dmnavbar),
    new NavbarContent(globalData.Navbar.Text3, themuseumnavbar), new NavbarContent("",aboutnavbar)
  ];

  function onBackgroundClicked() {
    menuItemClicked();
  }

  function menuItemClicked() {
    
    let modal = document.getElementById("modal");
    if (modal && menuOpened && typeof modal.close === 'function') {
      console.log("Closing because of menu item!")
      modal.close();
    }
    setNavMenu(false);
    setMenu(false);
  }

  function resetMenuADA(e) {
    dispatch(setSkipNavbarADA(false));
  }

  function setNavMenu(val) {
    var all = document.getElementsByClassName('nav-menu');
    for (var i = 0; i < all.length; i++) {
      all[i].style.display = val ? 'block' : 'none';
    }
  }


  function setMenu(val) {
    dispatch(setMenuOpened(val));
  }
  

  useEffect(() => {
    navContainer.current.onmouseover = function () {
      setNavMenu(true);
    };

    
    
  });

  function formatLinks(className, array, isActive, menuIndex) {
    //onFocus={(e) => { handleDesktopFocusIn(className, e) }}
    return (
      <div
        id={menuIndex === 0 ? 'nav-menu-id-stories' : 'nav-menu-id-exhibits'}
        className={
          desktopMenuOpened
          ?
          (menuOpened ? 'nav-menu nav-menu-key-opened open' : 'nav-menu nav-menu-key-opened ' + className)
          :
          (menuOpened ? 'nav-menu open' : 'nav-menu ' + className)
        }
        role={ADAARIARoles.None}
        aria-hidden={!(desktopMenuOpened || menuOpened)}
      >
        <div className="nav-menu-background" onClick={onBackgroundClicked} />
        <div className="nav-menu-content">
          <div className="close-icon-li" style={{display: isDesktopView ? "none" :""}}>
            <CloseIcon close={handleClick} label={globalData.Navbar.ADADescriptiveTextClose} tabIndex={!isDesktopView && menuOpened ? 0 : -1} role={ADAWidgitRoles.Button} />
          </div>
          {array.map((column, columnIndex) => (
            
            <div className="nav-column" key={columnIndex}>
              {menuIndex !== 0 &&
                <div className={`nav-header`} style={{ display: column.title ? "" : "none" }} //tabIndex={"-1"}
                  role={ADAARIARoles.Heading}>
                   {storyArchive.LatestStoriesLabel}
                </div>
              }
              <ul key={columnIndex} > 
                {menuIndex === 0 &&
                  <li className={'nav-item ' + cursor === column.items.length ? 'active' : null} key={-1} >
                    <Link to={`/${storyArchive.Menu.Path}/${storyArchive.Subpaths.LatestStories}`} className={`nav-links bold archive-item`} slot={menuIndex} 
                      onClick={menuItemClicked} onKeyDown={(e) => { handleMenuItemKeyDown(e, menuIndex); }} tabIndex={desktopMenuOpened && isActive ? 0 : -1} role={ADAWidgitRoles.Link} >
                      {storyArchive.LatestStoriesLabel}
                    </Link>
                  </li>
                }      
                {column.items && column.items.map((row, rowIndex) =>              
                  <li  className={'nav-item ' + cursor === rowIndex ? 'active' : null} key={rowIndex} >
                    <Link to={row.link} className={`nav-links ${row.bold ? 'bold' : ''}`} slot={menuIndex} 
                      onClick={menuItemClicked} onKeyDown={(e) => { handleMenuItemKeyDown(e, menuIndex); }} tabIndex={desktopMenuOpened && isActive ? 0 : -1} role={ADAWidgitRoles.Link} >
                      {row.title}
                    </Link>
                  </li>
                  )}
                {menuIndex === 0 &&
                  <li className={'nav-item ' + cursor === column.items.length ? 'active' : null} key={column.items.length} >
                    <Link to={`/${storyArchive.Menu.Path}/${storyArchive.Subpaths.ArchivedStories}`} className={`nav-links bold archive-item`} slot={menuIndex} 
                      onClick={menuItemClicked} onKeyDown={(e) => { handleMenuItemKeyDown(e, menuIndex); }} tabIndex={desktopMenuOpened && isActive ? 0 : -1} role={ADAWidgitRoles.Link} >
                      {storyArchive.Menu.Text}
                    </Link>
                  </li>
                }
              </ul>
            </div>
          ))}
        </div>
      </div>
    );
  }

  function formatLinksMobile(className, array, isActive) {
    return (
      <dialog id="modal" open={menuOpened ? 'open' : false}  style={{ display: menuOpened? 'block' : 'none' }}>
      <div className={menuOpened ? 'nav-menu open' : 'nav-menu ' + className} role={ADAARIARoles.None}>
        <div className="nav-menu-background" onClick={onBackgroundClicked} />
        <div className="nav-menu-content">
          <div className="close-icon-li" style={{display: isDesktopView ? "none" :""}}>
            <CloseIcon close={handleClick} label={globalData.Navbar.ADADescriptiveTextClose} tabIndex={!isDesktopView && menuOpened  ? 0 : -1} role={ADAWidgitRoles.Button} />
          </div>
          {array.map((column, columnIndex) => (
            <div className="nav-column" key={columnIndex}>
              <div className={`nav-header`} style={{ display: column.title ? "" : "none" }} //tabIndex={"-1"}
                role={ADAARIARoles.Heading}>
                 {column.title}
              </div>
              <ul key={columnIndex}>       
                {column.items && column.items.map((row, rowIndex) =>              
                  <li className="nav-item" key={rowIndex} > 
                    <Link to={row.link} className={`nav-links ${row.bold ? 'bold' : ''}`} 
                      onClick={menuItemClicked} tabIndex={isActive ? 0 : -1} role={ADAWidgitRoles.Link} >
                      {row.title}
                    </Link>
                  </li>
                  )}
                  {columnIndex === 0 &&
                    <li className="nav-item" key={column.items.length} >
                      <Link to={`/${storyArchive.Menu.Path}/${storyArchive.Subpaths.ArchivedStories}`} className={`nav-links bold archive-item`}
                        onClick={menuItemClicked} tabIndex={isActive  ? 0 : -1} role={ADAWidgitRoles.Link} >
                        {storyArchive.Menu.Text}
                      </Link>
                    </li>
                  }
              </ul>
            </div>
          ))}
        </div>
        </div>
        </dialog>
    );
  }

  const exhibitLinks = formatLinks('exhibit', exhibitContent, isDesktopView, 1);
  const featuredStoriesLinks = formatLinks('featured-stories', featuredStoriesContent, isDesktopView, 0);
  const mobileLinks = formatLinksMobile('mobile', mobileContent, !isDesktopView && menuOpened);

  return showNavbar  ? (
    <nav className={`navbar-container ${lightMode ? 'lightBg' : ''}`} ref={navContainer} >
      <a type="text" className="sr-only sr-skip" href="#main" tabIndex={!isShowingCredoPopup ? 0 : -1}>
        <span>Skip to main content</span>
      </a>
      <div className="desktop-navbar">
        <div className="navbar-holder" >
          <Link to={`/${globalData.Path.Text}/${globalData.Introduction.Menu.Path}`} role={ADAWidgitRoles.Link} aria-label="Verizon Story" className="navbar-logo" tabIndex={!menuOpened && !isShowingCredoPopup ? 0 : -1}>
            <img
              className="navbar-img"
              src={lightMode ? VerizonLogo : VerizonDarkLogo}
              alt="Verizon Logo"
            />
          </Link>
          <ul className="links-title" role={ADAARIARoles.None} >
            <li className={`main-link ${pathname.indexOf(`/${globalData.Path.Text}/${globalData.Onboarding.Menu.Menu.Path}`) === 0 ? 'active' : '' }`}>
              <Link to={`/${globalData.Path.Text}/${globalData.Onboarding.Menu.Menu.Path}`} role={ADAWidgitRoles.Link} tabIndex={isDesktopView && !menuOpened && !isShowingCredoPopup  ? 0 : -1}>
                {globalData && globalData.Navbar && globalData.Navbar.Text1}
              </Link>
            </li>
            <li className={`secondary-link ${desktopMenuOpened}`}  >
              <span tabIndex={isDesktopView && !menuOpened && !isShowingCredoPopup  ? 0 : -1} role={'button'} aria-expanded={desktopMenuOpened} aria-controls="nav-menu-id-stories" onClick={handleDesktopKeyPress} onKeyDown={(e) => { handleMenuItemKeyDown(e, 0); }} onKeyPress={handleDesktopKeyPress} >
                {globalData && globalData.Navbar && globalData.Navbar.Text2}
              </span>
              {featuredStoriesLinks}
            </li>
            <li
              
              className={`secondary-link ${
                pathname.indexOf('/pbp-home') === 0 || pathname.indexOf('/bbf') === 0
                  ? 'active'
                  : ''
              }`}
            >
              <span tabIndex={isDesktopView && !menuOpened  && !isShowingCredoPopup ? 0 : -1} role={'button'} aria-expanded={desktopMenuOpened} aria-controls="nav-menu-id-exhibits" onClick={handleDesktopKeyPress} onKeyDown={(e) => { handleMenuItemKeyDown(e, 1); }} onKeyPress={handleDesktopKeyPress} >
                {globalData && globalData.Navbar && globalData.Navbar.Text3}
              </span>
              {exhibitLinks}
            </li>
          </ul>
        </div>
      </div>
      <div className="mobile-navbar">
        <div className="navbar-holder">
          <Link to={`/${globalData.Path.Text}/${globalData.Introduction.Menu.Path}`} 
            className="navbar-logo" tabIndex={!isDesktopView && !menuOpened && !isShowingCredoPopup ? 0 : -1}>
            <img
              className="navbar-img"
              src={lightMode ? VerizonLogo : VerizonDarkLogo}
              alt="Verizon Logo"
            />
          </Link>
          <ToggleMenu toggle={handleClick} darkMode={lightMode} label={globalData.Navbar.ADADescriptiveTextOpen} style={{display: isDesktopView ? "none" :""}} tabIndex={!isDesktopView && !menuOpened && !isShowingCredoPopup  ? 0 : -1} role={ADAWidgitRoles.Button} />
        </div>
        {mobileLinks}
      </div>
    </nav>
  ) : null;
};

export default Navbar;
